import type { ReactNode } from "react"

interface SettingsItemProps {
  title: string
  description: string
  action: ReactNode
}

export function SettingsItem({ title, description, action }: SettingsItemProps) {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 p-4 rounded-lg bg-slate-50">
      <div className="flex flex-col">
        <p className="text-base font-bold text-slate-900">{title}</p>
        <p className="text-sm font-normal text-slate-600">{description}</p>
      </div>
      {action}
    </div>
  )
}
